export default {
  init() {
    // JavaScript to be fired on the home page

    if ( $( 'div' ).hasClass( 'slider') ) {
      $('.slider').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        fade: true,
      });
    }

    if ( $('div').hasClass( 'module-product' ) ) {
      $( '.module-product div.products' ).slick({
        arrows: true,
        infinite: true,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 665,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        }],
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js